import { useSearchParams } from 'react-router-dom';

export const useGetRangeQuery = () => {
  const [searchParams] = useSearchParams();
  const range = searchParams.get('range');

  const rangeQueryParams = range?.includes(',')
    ? {
        range: 'custom',
        startDate: range.split(',')[0],
        endDate: range.split(',')[1],
      }
    : range !== null
      ? {
          range,
        }
      : {};

  return { rangeQueryParams };
};
